import { ReactiveController, ReactiveControllerHost } from "lit";

export interface SurfacePositionControllerCfg {
    anchor: () => HTMLElement;
    surface: () => HTMLElement;
}

export class SurfacePositionController implements ReactiveController {
    constructor(
        private readonly host: ReactiveControllerHost,
        private readonly getConfig: () => SurfacePositionControllerCfg
    ) {
        this.host.addController(this);
    }

    hostConnected(): void {
        window.addEventListener('resize', this.reposition);
    }

    hostDisconnected(): void {
        window.removeEventListener('resize', this.reposition);
    }

    reposition = () => {
        console.warn("Reposition");
        const anchorEl = this.getConfig().anchor();
        const surfaceEl = this.getConfig().surface();

        if (!anchorEl || !surfaceEl) {
            console.log("no", { anchorEl, surfaceEl });
            return;
        }

        if (!anchorEl.isConnected || !surfaceEl.isConnected) {
            console.log("noConnected", { anchorEl, surfaceEl });
            return;
        };

        const anchorRect = anchorEl.getBoundingClientRect();
        const surfaceRect = surfaceEl.getBoundingClientRect();

        const top = anchorRect.bottom;
        const left = anchorRect.right - surfaceRect.width;

        surfaceEl.style.position = 'fixed';
        surfaceEl.style.top = `${top}px`;
        surfaceEl.style.left = `${left}px`;
    }
}